import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PrimaryButton } from '../../../components';
import { createResourceLocatorString } from '../../../util/routes';
import routeConfiguration from '../../../routing/routeConfiguration';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import css from './Sections.module.css';

function VisitSupplierSection() {
  const history = useHistory();
  const redirectToTrustedSuppliers = () => {
    history.push(createResourceLocatorString('TrustedSuppliersPage', routeConfiguration(), {}, {}));
  };
  return (
    <div className={css.trustedSupplierSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.trustedSupplierInfo}>
          <h2>
            <FormattedMessage id="FinancePage.VisitSupplierSection.title" />
          </h2>
          <p>
            <FormattedMessage id="FinancePage.VisitSupplierSection.description" />
          </p>
          <PrimaryButton
            className={css.trustedSupplierBtn}
            type="button"
            onClick={redirectToTrustedSuppliers}
          >
            <FormattedMessage id="FinancePage.VisitSupplierSection.button" />
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}

export default VisitSupplierSection;
